// Admin configuration data — Tipologie, Prestazioni estese, Bundle estesi, PDTA

// 6.1 Exam Types (tipologie esami)
export const examTypesData = [
  { id: "et1", name: "Esame strumentale", description: "Test eseguito con elettromedicale, restituisce solo valori",
    isInstrumental: true, requiresReport: false, isVisit: false, status: "attivo" },
  { id: "et2", name: "Esame strumentale con refertazione", description: "Test strumentale che genera referto firmato dal medico",
    isInstrumental: true, requiresReport: true, isVisit: false, status: "attivo" },
  { id: "et3", name: "Televisita strumentale", description: "Visita a distanza con esame strumentale in tempo reale",
    isInstrumental: true, requiresReport: true, isVisit: true, status: "attivo" },
  { id: "et4", name: "Televisita", description: "Visita medica a distanza, senza esami strumentali",
    isInstrumental: false, requiresReport: false, isVisit: true, status: "attivo" },
  { id: "et5", name: "Visita Specialistica", description: "Visita in presenza presso struttura accreditata",
    isInstrumental: false, requiresReport: false, isVisit: true, status: "testing" }
];

export const examTypeStatuses = ["draft", "testing", "attivo", "non_attivo"];
export const statusLabels = { draft: "Bozza", testing: "Testing", attivo: "Attivo", non_attivo: "Non attivo" };

// 6.2 Prestazioni — estensione dei servizi base con campi commerciali
export const serviceExtendedData = [
  { serviceId: "ecg", typeId: "et2", prezzoPubblico: 35, costoGestione: 4, costoFarmacia: 8, costoMedico: 18, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "2027-12-31" },
  { serviceId: "spirometria", typeId: "et2", prezzoPubblico: 45, costoGestione: 5, costoFarmacia: 10, costoMedico: 22, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "2027-12-31" },
  { serviceId: "emocromo", typeId: "et2", prezzoPubblico: 25, costoGestione: 3, costoFarmacia: 6, costoMedico: 12, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "2027-12-31" },
  { serviceId: "colesterolo", typeId: "et2", prezzoPubblico: 15, costoGestione: 2, costoFarmacia: 4, costoMedico: 9, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "2027-12-31" },
  { serviceId: "emoglobina_glicata", typeId: "et2", prezzoPubblico: 18, costoGestione: 2, costoFarmacia: 5, costoMedico: 9, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "2027-12-31" },
  { serviceId: "visus", typeId: "et2", prezzoPubblico: 20, costoGestione: 2, costoFarmacia: 5, costoMedico: 10, status: "testing", dataAttivazione: "2026-03-01", dataScadenza: "" },
  { serviceId: "glicemia", typeId: "et1", prezzoPubblico: 8, costoGestione: 1, costoFarmacia: 5, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" },
  { serviceId: "trigliceridi", typeId: "et1", prezzoPubblico: 12, costoGestione: 1, costoFarmacia: 8, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" },
  { serviceId: "pressione", typeId: "et1", prezzoPubblico: 5, costoGestione: 1, costoFarmacia: 3, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" },
  { serviceId: "ossimetria", typeId: "et1", prezzoPubblico: 5, costoGestione: 1, costoFarmacia: 3, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" },
  { serviceId: "temperatura", typeId: "et1", prezzoPubblico: 3, costoGestione: 0, costoFarmacia: 2, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" },
  { serviceId: "peso", typeId: "et1", prezzoPubblico: 5, costoGestione: 0, costoFarmacia: 4, costoMedico: 0, status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" }
];

// 6.3 Bundle — estensione con stato/date
export const bundleExtendedData = [
  { bundleId: "diabetes", status: "attivo", dataAttivazione: "2025-01-15", dataScadenza: "2027-12-31" },
  { bundleId: "cardiovascular", status: "attivo", dataAttivazione: "2025-02-01", dataScadenza: "2027-12-31" },
  { bundleId: "respiratory", status: "attivo", dataAttivazione: "2025-03-01", dataScadenza: "" },
  { bundleId: "complete", status: "testing", dataAttivazione: "2026-04-01", dataScadenza: "" },
  { bundleId: "basic", status: "attivo", dataAttivazione: "2025-01-01", dataScadenza: "" }
];

// 6.4 PDTA — Percorsi Diagnostico Terapeutici Assistenziali
// step.frequency.kind: "once" | "daily" | "weekly" | "monthly"
// step.frequency.every: ogni N (giorni/settimane/mesi)
// step.frequency.dayOfWeek: 1..7 (per weekly)
// step.frequency.weekOfMonth: 1..4 + dayOfWeek (per monthly "primo lunedì")
// step.frequency.dayOfMonth: 1..31 (per monthly fissa)
// step.startOffset: { value, unit: "days"|"weeks"|"months" }
// step.repetitions: numero ripetizioni
// step.durationDays: durata totale (per logica "fino a")
export const pdtaData = [
  {
    id: "pdta1",
    name: "Follow-up Diabete Tipo 2",
    description: "Monitoraggio trimestrale post-diagnosi diabete con controllo HbA1c, glicemia e parametri vitali",
    status: "attivo",
    createdAt: "2025-06-01",
    steps: [
      { id: "s1", serviceId: "glicemia", bundleId: null, startOffset: { value: 0, unit: "days" }, frequency: { kind: "weekly", every: 1, dayOfWeek: 1 }, repetitions: 12, durationDays: 84 },
      { id: "s2", serviceId: "emoglobina_glicata", bundleId: null, startOffset: { value: 0, unit: "months" }, frequency: { kind: "monthly", every: 3, dayOfMonth: 15 }, repetitions: 4, durationDays: 365 },
      { id: "s3", serviceId: null, bundleId: "diabetes", startOffset: { value: 6, unit: "months" }, frequency: { kind: "once", every: 1 }, repetitions: 1, durationDays: 0 }
    ]
  },
  {
    id: "pdta2",
    name: "Riabilitazione Cardiologica Post-IMA",
    description: "Programma 12 settimane post-infarto: ECG, pressione e bundle cardiovascolare",
    status: "attivo",
    createdAt: "2025-07-15",
    steps: [
      { id: "s1", serviceId: "pressione", bundleId: null, startOffset: { value: 0, unit: "days" }, frequency: { kind: "daily", every: 1 }, repetitions: 30, durationDays: 30 },
      { id: "s2", serviceId: "ecg", bundleId: null, startOffset: { value: 7, unit: "days" }, frequency: { kind: "weekly", every: 2, dayOfWeek: 1 }, repetitions: 6, durationDays: 84 },
      { id: "s3", serviceId: null, bundleId: "cardiovascular", startOffset: { value: 3, unit: "months" }, frequency: { kind: "once", every: 1 }, repetitions: 1, durationDays: 0 }
    ]
  },
  {
    id: "pdta3",
    name: "Monitoraggio Ipertensione",
    description: "Controllo PA settimanale + ECG mensile per 6 mesi",
    status: "draft",
    createdAt: "2026-01-20",
    steps: [
      { id: "s1", serviceId: "pressione", bundleId: null, startOffset: { value: 0, unit: "days" }, frequency: { kind: "weekly", every: 1, dayOfWeek: 2 }, repetitions: 26, durationDays: 182 },
      { id: "s2", serviceId: "ecg", bundleId: null, startOffset: { value: 0, unit: "months" }, frequency: { kind: "monthly", every: 1, weekOfMonth: 1, dayOfWeek: 1 }, repetitions: 6, durationDays: 182 }
    ]
  }
];

// PDTA activations (post-exam by doctor or pharmacist)
export const pdtaActivationsData = [
  // Empty by default; populated runtime
];

export const weekdayShort = ["", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
export const weekOrdinal = { 1: "Primo", 2: "Secondo", 3: "Terzo", 4: "Quarto" };

// Helper: human-readable frequency
export const describeFrequency = (f) => {
  if (!f) return "—";
  if (f.kind === "once") return "Una sola volta";
  if (f.kind === "daily") return f.every === 1 ? "Ogni giorno" : `Ogni ${f.every} giorni`;
  if (f.kind === "weekly") {
    const dow = weekdayShort[f.dayOfWeek] || "";
    return f.every === 1 ? `Ogni settimana (${dow})` : `Ogni ${f.every} settimane (${dow})`;
  }
  if (f.kind === "monthly") {
    if (f.weekOfMonth) {
      return `${weekOrdinal[f.weekOfMonth]} ${weekdayShort[f.dayOfWeek] || ""} del mese${f.every > 1 ? ` (ogni ${f.every} mesi)` : ""}`;
    }
    return f.every === 1 ? `Il ${f.dayOfMonth} di ogni mese` : `Il ${f.dayOfMonth} ogni ${f.every} mesi`;
  }
  return "—";
};

export const getExamTypeById = (id) => examTypesData.find(t => t.id === id);
export const getServiceExtendedById = (sid) => serviceExtendedData.find(s => s.serviceId === sid);
export const getBundleExtendedById = (bid) => bundleExtendedData.find(b => b.bundleId === bid);
export const getPdtaById = (id) => pdtaData.find(p => p.id === id);
